<div class="flex flex-col gap-1">
    <p class="font-bold">
        Account Type
    </p>
    <div class="flex flex-row gap-4 items-center">
        @if (isLoading) {
            <busy-spin [small]="true"></busy-spin>
        } @else {
            <div class="p-1 min-w-[12ch] text-center border rounded text-white" [style.border-color]="roleColor" [style.background]="roleColor">
                {{ role }}
            </div>
        }
        @if (canUpgradeAccount()) {
            <a href="/account/upgrade" class="text-center w-[12ch] p-1 bg-slate-100 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
                Upgrade
            </a>
        } @else if (canDowngradeAccount()) {
            <a href="/account/upgrade" class="text-center w-[12ch] p-1 bg-slate-100 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
                Downgrade
            </a>
        } @else {
            <!-- No action can be done for this role type outside of the ACP -->
        }
    </div>
    @if (canUpgradeAccount()) {
        <p class="text-xs text-slate-400">
            Remove ads and unlock additional features.
        </p>
    }
</div>